import { ReplacementPanelView } from 'src/views/replacement/replacement-panel';

const RestrictionsFacade = require('../../../facade/restrictions/restrictions');
const LibraryFactory = require('../../../factory/library').instance;
const ElementColorRestrictions = require('../../colors/element-color-restrictions');

module.exports = Backbone.View.extend({
  initialize: function (options) {
    this.selection = options.selection;

    $.when(LibraryFactory.get('palettes'), LibraryFactory.get('colors')).then(
      _.bind(function (palettes, libraryColors) {
        const elementColorRestrictions = new ElementColorRestrictions(
          options.selection.id,
          palettes,
          libraryColors,
          options.type || ''
        );
        this.colors = elementColorRestrictions.getRestrictedColors();
        this.render();
        options.hasOwnProperty('callback') && options.callback();
      }, this)
    );
  },

  getRestrictions: function (type) {
    return RestrictionsFacade.getElementRestrictions(this.selection.id, type);
  },

  initReplacementPanel: function (replacement, type) {
    const replacementView = ReplacementPanelView.getInstance(type);
    replacementView.closeApp();
    replacementView.mountApp({ type, workspace: CONFIG.company_id, replacement, onAssetClick: this.replaceItem });
  },

  replaceItem: function (asset) {
  },

  remove: function () {
    this.undelegateEvents();
    this.$el.removeData().unbind();
    Backbone.View.prototype.remove.call(this);
  },

  fromFolderResourceToSource: function (resource) {
    return {
      source: resource,
      thumbnail: resource
    };
  },

  getAllowedReplacements: async function (type) {
    const allowedReplacementSource =
      INKIVE.RestrictionsFacade.getElementRestrictions(
        this.selection.id,
        'source'
      );

    if (allowedReplacementSource.length === 0) {
      return {
        resources: null,
        folders: null
      };
    }

    const { list, library_folder: libraryFolder } =
      allowedReplacementSource[0] ?? {};

    if (list) {
      return {
        resources: list.map((resource) => this.fromFolderResourceToSource(resource)),
        folders: []
      };
    }
    if (!libraryFolder || libraryFolder.length === 0) {
      return {
        resources: [],
        folders: []
      };
    }

    if (libraryFolder.find((folder) => folder === 'all' || folder.resourceId === 'all')) {
      return {
        folders: [{
          resourceId: 'all',
          folderId: 'all'
        }],
        resources: []
      };
    } else {
      return {
        folders: libraryFolder.map(folder => {
          if (typeof folder === 'string') {
            return {
              resourceId: folder
            };
          } else {
            return {
              ...folder
            };
          }
        }),
        resources: []
      };
    }
  }
});
